import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import Home from '../screens/Home';
import Sections from '../screens/Sections';
import Chapters from '../screens/Chapters';
import Reading from '../screens/Reading';
import { Part } from '../entities/Part';
import { AppProvider } from '../Context/AppContext';
import Color from '../screens/Color';
import About from '../screens/About';

export type RootStackParamList = {
  Home: undefined,
  Sections: undefined,
  Chapters: { part: Part, partIndex: number },
  Reading: { 
    partIndex: number, 
    sectionIndex: number,
    comeFromHome: boolean
  },
  Color: undefined,
  About: undefined
}

const { Navigator, Screen } = createStackNavigator<RootStackParamList>();

const AppStack = () => {
  return (
    <AppProvider>
      <NavigationContainer>
        <Navigator screenOptions={{ headerShown: false }}>
          <Screen name="Home" component={Home} />
          <Screen name="Sections" component={Sections} />
          <Screen name="Chapters" component={Chapters} />
          <Screen name="Reading" component={Reading} />
          <Screen name="Color" component={Color} />
          <Screen name="About" component={About} />
        </Navigator>
      </NavigationContainer>
    </AppProvider>
  );
};

export default AppStack;